window.pages.faq = {
    init: function () {
        window.components.questions.init();
        window.components.faq.init();
    },
};
